"use client";
import { useState, useMemo } from "react";
import { CalendarAdmin } from "../../../components/admin/CalendarAdmin";
import { StudioSidebar } from "../../../components/admin/StudioSidebar";

export default function AdminSchedulePage() {
  return (
    <div className="flex h-screen bg-gray-100">
      <div className="flex-1 p-4">
        <CalendarAdmin />
      </div>
      <StudioSidebar />
    </div>
  );
}
